import { NewToggleList } from '../components/inventory/new-toggle-list.vue';
Vue.component('new-toggle-list', NewToggleList);